import {Stack} from "@mui/material";
import React, {ReactNode} from "react";
import {ButtonLayout, PositiveButtons} from "../button/ButtonLayout";
import {OkButton} from "../button/OkButton";
import Dialog, {DialogProps} from "./Dialog";
import DialogActions from "./DialogActions";
import DialogContent from "./DialogContent";
import DialogContentText from "./DialogContentText";
import DialogTitle from "./DialogTitle";

export interface DeleteConfirmationDialogProps {
    open: boolean;
    title: string;
    content: ReactNode;
    onClose: () => void;
    maxWidth?: DialogProps["maxWidth"];
}

export default function DeleteConfirmationDialog(props: Readonly<DeleteConfirmationDialogProps>) {
    const {open, title, content, onClose} = props;
    const maxWidth = props.maxWidth ?? 'sm';

    return (
        <Dialog open={open}
                onClose={onClose}
                maxWidth={maxWidth}>
            <DialogTitle title={title} onDialogClosed={onClose}/>
            <DialogContent>
                <Stack spacing={1}>
                    <DialogContentText>
                        {content}
                    </DialogContentText>
                </Stack>
            </DialogContent>
            <DialogActions>
                <ButtonLayout>
                    <PositiveButtons>
                        <OkButton onClick={onClose} />
                    </PositiveButtons>
                </ButtonLayout>
            </DialogActions>
        </Dialog>
    )
}
